import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import {
  ILocalization,
} from './interfaces';

const basePath = '/locales';

/* eslint-disable implicit-arrow-linebreak */

export const getLocalizations = (): AxiosPromise<IApiResponse<Array<ILocalization>>> =>
  vaultApi.getInstance().get(`${basePath}`);

export const getLocalizationsBySport = (sport: string): AxiosPromise<IApiResponse<Array<ILocalization>>> =>
  vaultApi.getInstance().get(`${basePath}`, {
    params: { sport },
  });
